import React from 'react';
import { Title, LinkText, Button, Notes } from 'common/components';
import { Glossary, BoardGL } from 'common/utils/glossary';

interface WelcomeBoardProps {
  /** WelcomeBoardの表示有無 */
  isDisplay: boolean;
  /** グロッサリ */
  glossary: Glossary;
  /** 選択している言語のグロッサリID */
  selectLangGlId: string;
  /** 言語選択をクリックした際の処理 */
  onClickLanguage: () => void;
  /** 国地域選択をクリックした際の処理 */
  onClickCountry: () => void;
  /** CanonIDでログインをクリックした際の処理 */
  onClickCanonIDLogin: () => void;
}

/**
 * 初回アクセス画面のPresentation Component
 */
export const WelcomeBoard: React.FC<WelcomeBoardProps> = ({
  isDisplay,
  glossary,
  selectLangGlId,
  onClickLanguage,
  onClickCountry,
  onClickCanonIDLogin
}) => {
  return isDisplay ? (
    <div className="welcomeBoard hideScrollbar" data-test="welcomeBoard">
      <Title type="title" data-test="welcomeBoardTitle">
        {glossary.glx(BoardGL.WelcomeTitle)}
      </Title>
      <LinkText
        type="language"
        data-test={`welcomeBoardLink`}
        onClick={onClickLanguage}
      >
        {glossary.glx(selectLangGlId)}
      </LinkText>
      <Notes
        notes={[
          glossary.glx(BoardGL.NoteTop),
          glossary.glx(BoardGL.NoteBottom)
        ]}
        data-test={`welcomeBoard-notes`}
      />
      <Button
        type="nextButton"
        subType="small"
        data-test={`welcomeBoard-countory-nextButton`}
        onClick={onClickCountry}
      >
        {glossary.glx(BoardGL.CountryButton)}
      </Button>
      <Button
        type="nextButton"
        subType="small"
        data-test={`welcomeBoard-login-nextButton`}
        onClick={onClickCanonIDLogin}
      >
        {glossary.glx(BoardGL.logInButton)}
      </Button>
    </div>
  ) : null;
};
